module.exports = __webpack_public_path__ + "img/27e804ed148b1d4b31c41999d212dc6a.png";